import App from "../App";
import HomePage from "./HomePage";
import ErrorPage from "./ErrorPage";
import Rollers from "./RollersPage";
import Wheels from "./WheelsPage";
import Accessories from "./AccessoriesPage";
import WelcomePage from "./WelcomePage";
import WheelsGuide from "./WheelsGuide";
import RollersGuide from "./RollersGuide";
import AccessoriesGuide from "./AccessoryGuide";

const routes = [
  {    
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true, element: <HomePage />         
      },
      {
        path: "Wheels",
        element: <Wheels />,     
      },
      {
        path: "Rollers",
        element: <Rollers />,
      },
      {
        path: "Accessories",
        element: <Accessories />,
      },
      {
        path: "Wheels/Guide",
        element: <WheelsGuide />
      },
      {
        path: "Rollers/Guide",
        element: <RollersGuide />
      },
      {
        path: "Accessories/Guide",
        element: <AccessoriesGuide />
      },
    ],
  },
  
  {
    path: "/Welcome",
    element: <WelcomePage />
  }
];

export default routes;
